import React from 'react';
import { connect } from 'react-redux';
import { Card, CardBlock, CardTitle , Button ,DropdownItem , DropdownMenu , Nav , NavItem, Dropdown , DropdownToggle} from 'reactstrap';

import ReactTable from "react-table";
import "react-table/react-table.css";
import IconEdit from 'react-icons/lib/md/edit';
import IconPersonAdd from 'react-icons/lib/md/person-add';

import * as actions from '../../actions/movimientocaclientes';
// import Modal from "./Modal";
import _ from "lodash";
import {API_URL,api} from '../../actions/_request';
import swal from 'sweetalert2';

import ModalCorreo from '../../components/complemento/ModalCorreo';


import IconPrint from 'react-icons/lib/fa/print';
import IconForms from 'react-icons/lib/fa/wpforms';
import IconTimbrar from 'react-icons/lib/fa/check-square-o';
import FaEnvelopeO from 'react-icons/lib/fa/envelope-o';
import IconBan from "react-icons/lib/fa/ban";
import IconsNote  from "react-icons/lib/fa/paperclip";



const requestData = (pageSize, page, sorted, filtered) => {    
    return new Promise((resolve, reject) => {
        // You can retrieve your data however you want, in this case, we will just use some local data.
        let filteredData ;
        var concepto="";
        var referencia="";
        var fecha="";
        var nombre_movimiento="";
        var cliente="";
        var take= pageSize;
        var skip=pageSize * page;
        var total=1;  
        for (var i = filtered.length - 1; i >= 0; i--) {
          switch(filtered[i].id)
          {
            case "concepto":
              concepto=filtered[i].value;
              break;
            case "referencia":
              referencia=filtered[i].value;
              break;            
            case "nombre_movimiento":
              nombre_movimiento=filtered[i].value;
              break;
            case "fecha":
              fecha=filtered[i].value;
              break;
            case "cliente":
              cliente=filtered[i].value;
              break;             
          }
        }
        api().get(`/movimientocac2/conteo?cliente=${cliente}&nombre_movimiento=${nombre_movimiento}&concepto=${concepto}&referencia=${referencia}&fecha=${fecha}&take=${take}&skip=${skip}`)
        .then(function(response)
        {
            if(response.status === 200)
            {
              total= response.data[0].total; 
              api().get(`/movimientocac2/busqueda?cliente=${cliente}&nombre_movimiento=${nombre_movimiento}&concepto=${concepto}&referencia=${referencia}&fecha=${fecha}&take=${take}&skip=${skip}`)
              .then(function(response)
              {
                if(response.status === 200)
                {
                  filteredData= response.data; 
                  // You can also use the sorting in your request, but again, you are responsible for applying it.
                  const sortedData = _.orderBy(
                    filteredData,
                    sorted.map(sort => {
                      return row => {
                        if (row[sort.id] === null || row[sort.id] === undefined) {
                          return -Infinity;
                        }
                        return typeof row[sort.id] === "string"
                        ? row[sort.id].toLowerCase()
                        : row[sort.id];
                      };
                    }),
                    sorted.map(d => (d.desc ? "desc" : "asc"))
                  );
                  const res = {
                    rows: sortedData,
                    pages: Math.ceil(total / pageSize)
                  };
                  // Here we'll simulate a server response with 500ms of delay.
                  //setTimeout(() => resolve(res), 1000);
                  //console.log(res);
                  resolve(res)
                }
              });   
            }
        });
    });
};
class Descuentos extends React.Component {

    constructor(props) {

        super(props);

        this.state = {
            modal       : false,
            prospectoid : null,
            title       : "",
             data: [],
             pages: null,
             loading: true,
             modal_correo:false,

        };
        this.toggle 			= this.toggle.bind(this);
        this.opciones       = this.opciones.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.cancelar_sin_timbrar  = this.cancelar_sin_timbrar.bind(this);
        this.timbrar  = this.timbrar.bind(this);
        this.cancelar  = this.cancelar.bind(this);
         this.toggle_correo  = this.toggle_correo.bind(this);
    }

    toggle_correo(evt=[],factura=[]){ 

        // console.log('factura--->',factura);
        this.setState({
              modal_correo : !this.state.modal_correo, 
              factura : factura.value,
              cliente : factura.cliente_id,
          });
    }

    cancelar(evt, factura){
      // console.log('Factura------>',factura)
      let self = this;
      swal.queue([{
        title: 'Estas seguro?',
        text: "Se Cacelara el Movimiento "+factura.referencia+" para "+factura.cliente+' Por la cantidad de '+factura.total,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
        cancelButtonText: 'Cancelar!',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return api().get('/movimientocac/cancelar_cfdi/'+factura.value)
            .then(function(response)
            {    
                // console.log('response-->',response)    
                if(response.status === 200)
                {
                  // console.log('entor al status 200');
                  // console.log('factura-->',response.data.factura) ;
                  if(parseInt(response.data.estado)==200){
                     self.props.actualizar_renglon(response.data.movimiento);
                     window.open(API_URL+'/movimientocac/pdf/'+factura.value);
                  }
                  //  if(parseInt(response.data.estado)==210){
                  //    swal.insertQueueStep({
                  //     type: 'error',
                  //     title: 'La Factura Cuenta Con Abonos'
                  //   })
                  // }
                  if(parseInt(response.data.estado)==500){
                    console.log('Mensaje de error--->',response.data.error.descripcion)
                    swal.insertQueueStep({
                        type: 'error',
                        title: response.data.error.descripcion
                      })

                   }
                 
                }
            })
            .catch(() => {
              swal.insertQueueStep({
                type: 'error',
                title: 'Solicitar ayuda a un Administrador',
              })
            })
        }
      }])
    }

    timbrar(evt, complemento){
      // console.log('complemento------>',complemento)
      let self = this;
      swal.queue([{
        title: 'Estas seguro?',
        text: "Se Timbrara El Movimiento para "+complemento.cliente+' Por la cantidad de '+complemento.total,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
        cancelButtonText: 'Cancelar!',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return api().get('/movimientocac/timbrar/'+complemento.value)
            .then(function(response)
            {    
                console.log('response-->',response)    
                if(response.status === 200)
                {
                  

                  if(parseInt(response.data.estado)==200){
                    // console.log('entor al status 200');
                    // console.log('complemento-->',response.data.complemento) ;
                    self.props.actualizar_renglon(response.data.movimiento);
                    // console.log('liga pdf-->  '+API_URL+'/pdf_complemento/'+complemento.value+'/I');
                    window.open(API_URL+'/movimientocac/pdf/'+complemento.value);
                  }else{
                    console.log('Mensaje de error--->',response.data.mensaje)
                    swal.insertQueueStep({
                        type: 'error',
                        title: response.data.mensaje
                      })

                   }
                }
            })
            .catch(() => {
              swal.insertQueueStep({
                type: 'error',
                title: 'Solicitar ayuda a un Administrador'
              })
            })
        }
      }])
    }
    cancelar_sin_timbrar(evt, movimiento){
      console.log('movimiento------>',movimiento)
      let self = this;
      swal.queue([{
        title: 'Estas seguro?',
        text: "Se Cacelara la movimiento "+movimiento.referencia+" para "+movimiento.cliente+' Por la cantidad de '+movimiento.total,
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Estoy Seguro!',
        cancelButtonText: 'Cancelar!',
        showLoaderOnConfirm: true,
        preConfirm: () => {
          return api().get('/movimientocac/cancelar/'+movimiento.value)
            .then(function(response)
            {    
                // console.log('response-->',response)    
                if(response.status === 200)
                {
                  // console.log('entor al status 200');
                  // console.log('movimiento-->',response.data.movimiento) ;
                  if(parseInt(response.data.estado)==200){
                     self.props.actualizar_renglon(response.data.movimiento);
                  }
                   if(parseInt(response.data.estado)==210){
                     swal.insertQueueStep({
                      type: 'error',
                      title: 'La movimiento esta Timbrado'
                    })
                  }
                  if(parseInt(response.data.estado)==500){
                    console.log('Mensaje de error--->',response.data.error.descripcion)
                    swal.insertQueueStep({
                        type: 'error',
                        title: response.data.error.descripcion
                      })

                   }
                 
                }
            })
            .catch(() => {
              swal.insertQueueStep({
                type: 'error',
                title: 'Solicitar ayuda a un Administrador',
              })
            })
        }
      }])
    }
    get_cliente(cliente = null){
    
    
          
  
  }
 fetchData(state, instance) {
    // Whenever the table model changes, or the user sorts or changes pages, this method gets called and passed the current table model.
    // You can set the `loading` prop of the table to true to use the built-in one or show you're own loading bar if you want.
    this.setState({ loading: true });
    // Request the data however you want.  Here, we'll use our mocked service we created earlier
    requestData(
      state.pageSize,
      state.page,
      state.sorted,
      state.filtered
    ).then(res => {
      // Now just get the rows of data to your React Table (and update anything else like total pages or loading)
      this.setState({
        data: res.rows,
        pages: res.pages,
        loading: false
      });
      this.props.get(res.rows);
    });
  }
   opciones( id = null, title = "Agregar Almacen", tipo=0)
    {
        this.props.formulario(id,title,tipo);
    }

  toggle(menu,id) {
    let valor=0;

    if(menu===1){
      if(parseInt(this.state.menu)!==id)
        valor=id;
        this.setState({
          menu: valor
        });
    }else{
      if(parseInt(this.state.submenu)!==id)
        valor=id;
        this.setState({
          submenu: valor
        });
    }
  }

    componentDidMount() {

       // this.props.get();
    }

    render() {
        const { data, pages, loading } = this.state;
          // console.log("tabla")
        return(
            <div className="view">
           

                <div className="view-header">
                    <header className="title text-white">
                        <h1 className="h4 text-uppercase">Cargos/Abonos de Clientes</h1>
                    </header>
                </div>

                <div className="view-content view-components">
                    <Card>
                        <CardBlock>
                        <div className="row justify-content-end">
                          <div className="col-3 mb-4 pr-4">
                            <div className="mr-5 text-right float-right">
                                <Dropdown nav isOpen={parseInt(this.state.menu)===1?true:false} toggle={() => {this.toggle(1,1);}} >
                                  <DropdownToggle nav caret>
                                   Agregar
                                  </DropdownToggle>
                                  <DropdownMenu className='letras_menu'>
                                    <DropdownItem onClick={() => {this.opciones(null,'Cargos y Abonos',1);}}>Cargos y Abonos</DropdownItem>
                                    <DropdownItem onClick={() => {this.opciones(null,'Notas de Abono/Credito',2);}}>Notas de Abono/Credito</DropdownItem>
                                  </DropdownMenu>
                                </Dropdown> 
                            </div>
                          </div>
                        </div>
                            <ReactTable
                              getTrProps={(state, rowInfo, column) => {
                                  
                                  if(rowInfo === undefined){
                                          
                                          return{
                                          }
                                        }else{
                                           return{

                                            onDoubleClick: (e) => {
                                          if(parseInt(rowInfo.original.timbrado)==0){
                                            this.opciones(rowInfo.original.value, 'editar',rowInfo.original.tipo_movimiento_id);
                                          }else{
                                            swal('', 'Movimiento Timbrado no se puede editar');
                                          }
                                        }






                                           
                                        } 
                                    }
                              }}
                             
                              className = "-striped -highlight"
                              columns   = {[
                               
                                

                              
                                {
                                    Header: 'Controles',
                                    filterable: false,
                                    sortable: false,
                                    minWidth:250,
                                    Cell: (row) =>
                                    {
                                        return(
                                            <div className="text-right">
                                            {
                                              (parseInt(row.original.timbrado)==0&&parseInt(row.original.cancelado)==0)&&
                                                <Button
                                                 color="success"  
                                                 onClick={(evt)=>this.opciones(row.original.value, 'editar',row.original.tipo_movimiento_id)}>
                                                    <IconEdit />
                                                </Button>
                                              } {' '}
                                                <a href={API_URL+"/movimientocac/pdf/"+row.original.value} target="_blank">
                                                      <Button color="secondary" title=" Imprimir Facturar" >
                                                          <IconPrint  />
                                                      </Button>
                                                  </a>
                                                  {' '}

                                           
                                                <Button color={parseInt(row.original.enviada)==1?"info":"secondary"}
                                                 title=" Enviar Facturar"
                                                 onClick={(evt)=>this.toggle_correo(evt, row.original)}>
                                                  <FaEnvelopeO />
                                                </Button>

                                              {' '}
                                                 {
                                              (parseInt(row.original.cancelado)==0 && parseInt(row.original.timbrado)==0)&&
                                              <Button
                                                 color="warning" 
                                                 title=" Cancelar (Sin Timbrado) " 
                                                 onClick={(evt)=>this.cancelar_sin_timbrar(evt, row.original)}>
                                                    <IconBan />
                                                </Button>
                                            }
                                            {
                                              (parseInt(row.original.timbrado)==1&&parseInt(row.original.cancelado)==0)&&
                                              <Button
                                                 color="danger" 
                                                  title=" Cancelar (Timbrado)"
                                                 onClick={(evt)=>this.cancelar(evt, row.original)}>
                                                    <IconBan />
                                                </Button>
                                            }
                                            {' '}
                                            {
                                              (parseInt(row.original.timbrado)==0&&parseInt(row.original.tipo_doc)==1&&parseInt(row.original.cancelado)==0)&&
                                              <Button
                                                 color="success" 
                                                  title=" Timbrar Facturar"
                                                 onClick={(evt)=>this.timbrar(evt, row.original)}>
                                                    <IconTimbrar />
                                                </Button>
                                            }

                                                 
                                            </div>
                                        )
                                    }
                                },
                                {Header: 'Estado', accessor: 'estado',maxWidth:150,minWidth:150 , style: { 'textAlign': 'center'}},
                                // {Header: 'Tipo', accessor: 'nombre_movimiento',maxWidth:150,minWidth:150 , style: { 'textAlign': 'center'}},
                                {Header: 'Concepto', accessor: 'concepto',minWidth:500, style: { 'textAlign': 'center'}},
                                {Header: 'Referencia', accessor: 'referencia',minWidth:200, style: { 'textAlign': 'center'}},
                                {Header: 'Fecha', accessor: 'fecha',maxWidth:150,minWidth:150 , style: { 'textAlign': 'center'}},
                                {Header: 'Cliente', accessor: 'cliente',minWidth:500, style: { 'textAlign': 'center'}},
                                {Header: 'Subtotal', accessor: 'subtotal',maxWidth:150,minWidth:150 , filterable: false, sortable: false, style: { 'textAlign': 'center'}},
                                {Header: 'Impuestos', accessor: 'impuestos',maxWidth:150,minWidth:150 , filterable: false, sortable: false, style: { 'textAlign': 'center'}},
                                {Header: 'Total', accessor: 'total',maxWidth:150,minWidth:150 , filterable: false, sortable: false, style: { 'textAlign': 'center'}},
                              
                              ]}
                            
                              manual // Forces table not to paginate or sort automatically, so we can handle it server-side
                              data={this.props.movimientocaclientes.data}
                              pages={pages} // Display the total number of pages
                              loading={loading} // Display the loading overlay when we need it
                              onFetchData={_.debounce(this.fetchData, 500)} // Request new data when things change
                              filterable
                              defaultPageSize={10}
                             
                              
                             
                            />
                        </CardBlock>
                    </Card>
                </div>  
                { this.state.modal_correo&&
                    <ModalCorreo
                        open={this.state.modal_correo}
                        toggle={this.toggle_correo}  
                        cliente={this.state.cliente} 
                        factura={this.state.factura}
                    />
                }              

            </div>
        );
    }

};

function mapStateToProps(state, ownProps) {
    return {
        movimientocaclientes : state.movimientocaclientes,
        notificciones:state.notificciones,
    }
};

export default connect(mapStateToProps, actions)(Descuentos)


// WEBPACK FOOTER //
// ./src/views/movimientoscaclientes/tabla.js